// Hideo - tag name helpers: tags are compared without case ("Wiki" and "wiki" are the same tag)
export const sameTag = (a: string, b: string): boolean => a.toLowerCase() === b.toLowerCase()
/** Same list without case-insensitive duplicates (the first spelling wins) */
export const uniqTags = (list: string[]): string[] => list.filter((tag, i) => list.findIndex(x => sameTag(x, tag)) === i)
export const hasTag = (list: string[], tag: unknown): boolean => list.some(x => x.toLowerCase() === String(tag).toLowerCase())
/** Longest tag name */
export const TAG_NAME_MAX = 30
